import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  fieldContainer: {
    marginBottom: theme.spacing('large'),
  },
  helperText: {
    margin: [theme.spacing('small'), theme.spacing('large'), 0],
  },
}));
